/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ main: NonNullable<unknown>, foreign: NonNullable<unknown> }} Snackbar_Mappingassigned1Inputs */

const en_snackbar_mappingassigned1 = /** @type {(inputs: Snackbar_Mappingassigned1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} successfully assigned to ${i?.foreign}.`)
};

const de_snackbar_mappingassigned1 = /** @type {(inputs: Snackbar_Mappingassigned1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} wurde erfolgreich ${i?.foreign} zugeordnet.`)
};

/**
* | output |
* | --- |
* | "{main} successfully assigned to {foreign}." |
*
* @param {Snackbar_Mappingassigned1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const snackbar_mappingassigned1 = /** @type {((inputs: Snackbar_Mappingassigned1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snackbar_Mappingassigned1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_snackbar_mappingassigned1(inputs)
	return de_snackbar_mappingassigned1(inputs)
});
export { snackbar_mappingassigned1 as "snackbar_mappingAssigned" }